// client/src/components/Checkbox.js
import React from "react";
import HeadingBuilder from './HeadingBuilder';
  
const Checkbox = ({
  size = 'small',
  label, tippyAlert, tippyInfo, isChecked,
  setIsChecked = function() {},
}) => {
  return (
    <div>
      <label className="container-hug-bottom">
        <HeadingBuilder
          Size           = {size}
          headingText    = {label}
          tippyAlertText = {tippyAlert}
          tippyText      = {
            (tippyAlert && tippyAlert.length > 0)
              ? tippyAlert
              : tippyInfo
          }
          tippyInfoText  = {tippyInfo}
        />
        &nbsp;
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => {
            setIsChecked(!isChecked);
          }}
        />
      </label>
    </div>
  );
};

export default Checkbox;

